import React from "react";

export const ProgressBar = ({ progress }: { progress: number }) => {
  return (
    <div
      className="h-1 bg-primary-200 transition-all duration-500 ease-linear mt-[8px] border rounded-[2px]"
      style={{ width: `${progress}%` }}
    ></div>
  );
};
